var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kv-ve-divider",class:{ 'is-selected': _vm.selected }},[_c('div',{staticClass:"kv-ve-divider__line",style:({
      width: _vm.widthPctStyle,
      margin: _vm.widthPctMargin,
      borderTop:
        (Number(_vm.block.settings.thickness) || 1) +
        'px solid ' +
        (_vm.block.settings.color || '#e5e7eb'),
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }